import { createComponent } from "@helpers/admin";
import DeliveryTermsSectionComponent from "@template/blocks/DeliveryTermsSection/component";

export const DeliveryTerms = createComponent({
  label: "Delivery Terms",
  component: DeliveryTermsSectionComponent,
  fields: {
    definitions: {
      label: "Definitions",
      type: "array",
      arrayFields: {
        text: {
          label: "Text",
          type: "textarea",
        },
      },
    },
    sections: {
      label: "Sections",
      type: "array",
      arrayFields: {
        title: {
          label: "Title",
          type: "textarea",
        },
        content: {
          label: "Content",
          type: "array",
          arrayFields: {
            text: {
              label: "Text",
              type: "textarea",
            },
          },
        },
      },
    },
  },
});
